module.exports = __webpack_public_path__ + "static/assets/6c002d6cc03cd61a4bdcd3937bbb116b.svg";